import React from 'react';

export const FormContext = React.createContext({
	rowOptions: null,
	formValuesById: null,
	setFormValuesById: null,
	formId: null,
	accountInfoForm: null,
});
